import { Route, HashRouter as Router, Routes } from "react-router-dom";
import Admin from "./components/Admin";
import Approval from "./components/Approval";
import Cashier from "./components/Cashier";
import Chef from "./components/Chef";
import Home from "./components/Home";
import Homepage from "./components/Homepage";
import Printing from "./components/Printing";
// Remove direct imports of Transfer and Revenue since they'll be rendered inside Admin
// import Transfer from "./components/Transfer";
// import Revenue from "./components/Revenue";

function App() {
  return (
    <Router>
      <Routes>

        {/* ================= PUBLIC ROUTES ================= */}
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/chef" element={<Chef />} />

        {/* ================= CASHIER ROUTES ================= */}
        <Route path="/cashier" element={<Cashier />} />
        <Route path="/cashier/approval" element={<Approval />} />
        <Route path="/cashier/print" element={<Printing />} />

        {/* ================= ADMIN ROUTES ================= */}
        {/* All admin routes should render the Admin component which handles the layout */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/orders" element={<Admin />} />
        <Route path="/admin/purchases" element={<Admin />} />
        <Route path="/admin/payments" element={<Admin />} />
        <Route path="/admin/expenses" element={<Admin />} />
        <Route path="/admin/menu" element={<Admin />} />

        {/* ================= EMPLOYEE ROUTES ================= */}
        <Route path="/admin/employees/contract" element={<Admin />} />
        <Route path="/admin/employees/nocontract" element={<Admin />} />

        {/* ================= TRANSFER ROUTE ================= */}
        {/* Changed from <Transfer /> to <Admin /> so it renders inside the admin layout */}
        <Route path="/admin/transfer" element={<Admin />} />

        {/* ================= REPORT ROUTES ================= */}
        <Route path="/admin/reports/sales" element={<Admin />} />
        <Route path="/admin/reports/performance" element={<Admin />} />
        <Route path="/admin/reports/financial" element={<Admin />} />
        <Route path="/admin/reports/cash" element={<Admin />} />
        {/* Changed from <Revenue /> to <Admin /> so it renders inside the admin layout */}
        <Route path="/admin/reports/revenue" element={<Admin />} />

      </Routes>
    </Router>
  );
}

export default App;